export default __webpack_public_path__ + "static/media/Tool3.ee936509.png";